import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ToolbarSimple from '../../../Utils/Toolbar/ToolbarSimple';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";
import {RenderCurrency, RenderNumber} from "../../../Utils/renderField/renderReadField";
import { getSimbolo} from "../../../Utils/renderField/renderTableField";
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { renderField, AsyncSelectField, renderTextArea } from '../../../Utils/renderField';

class ItemArray extends Component{

    render(){
        const {index, itemDetail, orden, detalle, detallesOrden, eliminar }= this.props;

        return(
            <tr key={index} style={{height:"68px"}}>
                <td className="text-center sin-borde-top" style={{width: "48px"}}>
                    {/*
                    <img className="action-img" src={require('assets/img/icons/Cerrar.png')} alt="Borrar"
                        title="Borrar"
                        onClick={() =>{
                            eliminar()
                        }}
                    />
                    */}
                </td>
                <td className="sin-borde-top">
                    <Field
                        name={`${itemDetail}.producto.nombre`}
                        type="text"
                        readOnly
                        // min="0" max="5"
                        component={renderField}
                        top ={{top:"67px", position:"inherit"}}
                        clase="inputRead2"
                    />
                </td>
                <td className="sin-borde-top">
                    <label><RenderNumber value={detalle.cantidad} decimalScale={(detalle.cantidad) % 1 == 0 ? 0:4}/></label>
                </td>
                <td className="sin-borde-top">
                    <label><RenderNumber value={detalle.cantidad_reportada} decimalScale={(detalle.cantidad_reportada) % 1 == 0 ? 0:4}/></label>
                </td>

                { detalle.cantidad_pendiente == 0 && detalle.cantidad_reportada == detalle.cantidad ?
                    <td className="sin-borde-top">
                        <label><RenderNumber value={detalle.cantidad_pendiente} decimalScale={(detalle.cantidad_pendiente) % 1 == 0 ? 0:4}/></label>
                    </td>
                    :
                    <td className="sin-borde-top" >
                        <Field
                            name={`${itemDetail}.cantidad_pendiente`}
                            type="number"
                            // min="0" max="5"
                            component={renderField}
                            top ={{top:"67px", position:"inherit"}}
                        />
                    </td>
                }

            </tr>
        )
    }
}

const renderDetallesOrden = ({ fields, meta: {error, submitFailed }, orden }) => (
    <div className=" col-sm-12 p-0">
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="col-sm-12 form-group np-r  mt-2 sin-borde p-0">
                <table className="table table-hover table-bordered table-sm table-responsive-sm m-0 table-striped">
                    <thead>
                    <tr>
                        <th></th>
                        <th>PRODUCTO</th>
                        <th style={{width: "15%"}}>CANTIDAD SOLICITADA</th>
                        <th style={{width: "15%"}}>CANTIDAD REPORTADA</th>
                        <th style={{width: "15%"}}>CANTIDAD PENDIENTE</th>
                    </tr>
                    </thead>
                    <tbody >
                        {fields.map((item, index) => {
                            let detalles_orden = fields.getAll();
                            let detalle = fields.get(index);

                            return(
                                <ItemArray
                                    key={index}
                                    index={index}
                                    itemDetail={item}
                                    orden={orden}
                                    detalle={detalle}
                                    detallesOrden={detalles_orden}
                                    // eliminar={ () =>{fields.remove(index)}}
                                />
                            )
                        })}
                    </tbody>
                </table>
            </div>

            {/*
            <div className="d-flex justify-content-start mt-2">
                <button type="button" className="btn btn-primary py-0" onClick={() => fields.push({})}>
                    AGREGAR DESPACHO
                </button>
            </div>
            */}

        </div>

        {/* Errors */}
        {submitFailed && error &&
            <div className="invalid-feedback-array text-danger">
                {error}
            </div>
        }

    </div>
)

class ReporteProduccionOPForm extends Component {

    componentWillMount() {
        this.preCargarDetalles();
    }

    round_ = (cantidad) => {return Math.round(cantidad * 10000) / 10000;}

    preCargarDetalles = () => {
        const { orden } = this.props;

        const despachosIniciales = orden.detalle_orden.map((d) => ({
            producto: d.producto,
            cantidad: this.round_(d.cantidad),
            cantidad_reportada: this.round_(d.cantidad - d.cantidad_actual),
            cantidad_pendiente: this.round_(d.cantidad_actual),
        }));
        this.props.initialize({ detalle_orden: despachosIniciales });

    };

    render() {
        const { orden, loader, handleSubmit, openModalHistorial, rechazarDespacho, guardarDespacho, listar: onPageChange, onSortChange, } = this.props;

        return (
            <div className="row mt-0 pt-0">
                <div className="mb-4 col-12 px-0 mx-0">
                    <div className="mb-4 ">
                        <div className="p-0 px-3 pt-0 p-b">
                            <form name="ReporteProduccionOPForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
                                <FieldArray
                                    name="detalle_orden"
                                    component={renderDetallesOrden}
                                    orden={orden}
                                    // getProductosOrden={this.getProductosOrden}
                                />
                                <div className="col-12">
                                    <button className="btn btn-mostaza m-1 align-self-center" type="button" onClick={openModalHistorial}>VER HISTORIAL</button>
                                    {!loader &&
                                        <button className="btn btn-primary m-1 align-self-center" type="submit">REPORTAR PRODUCCIÓN</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


ReporteProduccionOPForm = reduxForm({
    form: 'ReporteProduccionOPForm', // a unique identifier for this form
    validate: (data, props) => {
        const errors = {};

        if (!data || !data.detalle_orden || !data.detalle_orden.length) {
            errors.detalle_orden = {_error:'Debe despachar al menos un producto'}
        }
        else {
            const despachoArray = []

            data.detalle_orden.forEach((detalle, index) => {
                let detErrors = {};

                if (!detalle.cantidad_pendiente) detErrors.cantidad_pendiente = "Campo requerido.";
                if (detalle.cantidad_pendiente) {
                    if (parseFloat(detalle.cantidad_pendiente) < 0) detErrors.cantidad_pendiente = "Debe ser mayor a 0.";
                    if (parseFloat(detalle.cantidad_pendiente) > detalle.cantidad) detErrors.cantidad_pendiente = `Debe ser menor a ${detalle.cantidad}.`;
                }
                if (detErrors) despachoArray[index] = detErrors;

            });
            if (despachoArray.length) errors.detalle_orden = despachoArray;
        }
        return errors
    },
})(ReporteProduccionOPForm);


export default ReporteProduccionOPForm;